/**
 * Global Navigation Toggle
 */

let scrollPosition = 0;

const disableScroll = () => {
    scrollPosition = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
};

const enableScroll = () => {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);
};

const openNav = () => {
    const body = document.body;
    const hamburger = document.getElementById( 'js-hamburger' );
    const globalNav = document.querySelector( '.p-global-nav' );

    if ( hamburger && globalNav ) {
        hamburger.addEventListener( 'click', function() {
            const isOpen = hamburger.classList.toggle( 'is-active' );
            globalNav.classList.toggle( 'is-open' );
            body.classList.toggle( 'nav-open' );
            
            // Update aria-label and handle scroll
            if ( isOpen ) {
                hamburger.setAttribute( 'aria-label', 'メニューを閉じる' );
                disableScroll();
            } else {
                hamburger.setAttribute( 'aria-label', 'メニューを開く' );
                enableScroll();
            }
        });
    }
}
document.addEventListener( 'DOMContentLoaded', openNav );

const closeNav = () => {
    const body = document.body;
    const hamburger = document.getElementById( 'js-hamburger' );
    const globalNav = document.querySelector( '.p-global-nav' );
    const backgroundBlur = document.getElementById( 'js-background-blur' );

    if ( backgroundBlur && globalNav && hamburger ) {
        backgroundBlur.addEventListener( 'click', function() {
            const isOpen = hamburger.classList.contains( 'is-active' );
            if ( isOpen ) {
                hamburger.classList.remove( 'is-active' );
                globalNav.classList.remove( 'is-open' );
                body.classList.remove( 'nav-open' );
                // Update aria-label and enable scroll
                hamburger.setAttribute( 'aria-label', 'メニューを開く' );
                enableScroll();
            }
        });
    }
}
document.addEventListener( 'DOMContentLoaded', closeNav );